import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderDataService {
 


  // private apiUrl = "http://localhost:3003/api";
  apiUrl = "https://lexipackghana.com:3003/api";


  constructor(private http: HttpClient) { }

  UnsavedOrder(data: any, orderId:any) {
    return this.http.post(this.apiUrl + '/unsaved-orders/'+orderId, data);
  }
  
    // Method to get all unsaved orders
    getAllUnsavedOrders() {
      return this.http.get(`${this.apiUrl}/unsaved-orders`);
    }
  
    // Method to get all unsaved orders
    getAllunsavedOrdersDisp() {
      return this.http.get(`${this.apiUrl}/unsavedOrdersDisp`);
    }
  
    // Method to get a specific unsaved order by ID
    getUnsavedOrderById(id: string) {
      return this.http.get(`${this.apiUrl}/unsaved-orders/${id}`);
    }

    // Method to delete multiple clients by IDs
    deleteAllUnsavedOrder(ids: string[]) {
      return this.http.delete<any>(this.apiUrl + '/deleteAllunsaved-orders', { body: { ids } });
    }

    // Example method to fetch MatMix data by orderId
    getUnsavedOrderByJssId(jssId: string) {
      const url = `${this.apiUrl}/UnsavedOrderByJssId/${jssId}`; // Adjust endpoint URL
      return this.http.get<any[]>(url);
    }
    // Method to get the order status
    getOrderStatus(orderId: string){
      return this.http.get<any>(`${this.apiUrl}/${orderId}/status`);
    }

    // Method to get all orders
    getAllOrders(page:any, limit:any, data:any) {
      return this.http.post(`${this.apiUrl}/getAllOrders?page=`+page+`&limit=`+limit,data);
    }
    getClientNames() {
      return this.http.get(`${this.apiUrl}/getClientNames`);
    }
    getExportOrders(data:any) {
      return this.http.post(`${this.apiUrl}/exportOrders`,data);
    }
 // Method to get all unsaved orders ticket numbers
//  getAllUnsavedOrdersTicket() {
//   return this.http.get<{ ticketno: string }[]>(this.apiUrl + '/getAllUnsavedOrdersTicket').pipe(
//     map((unsavedOrders) => unsavedOrders.map(order => order.ticketno))
//   );
// }


}

